import config from '@bedrock-rdk/config';

export const getMatchingSkeleton = (entityType, entityId, section = 'main') => {
  const hasSkeletonConfig = config.skeleton && Array.isArray(config.skeleton.patterns);
  if (!hasSkeletonConfig || !entityType) {
    return null;
  }

  return (
    config.skeleton.patterns
      .filter(({ section: pattern }) => !pattern || section === pattern)
      .find(({ path: pattern }) => {
        try {
          const result = Boolean(`app/${entityType}/${entityId}`.match(new RegExp(pattern, 'i')));
          // eslint-disable-next-line no-console
          console.log(`[routing.utils] Testing skeleton ${pattern} against "app/${entityType}/${entityId}": ${result}`);

          return result;
        } catch (error) {
          return false;
        }
      }) || null
  );
};
